/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalAgreement_requestUpdatePortalAgreement } from '../models/api_portalAgreement_requestUpdatePortalAgreement';
import type { api_portalAgreement_responseUpdatePortalAgreement } from '../models/api_portalAgreement_responseUpdatePortalAgreement';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalAgreementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Update PortalAgreement
     * Update PortalAgreement
     * @returns api_portalAgreement_responseUpdatePortalAgreement responseUpdatePortalAgreement
     * @throws ApiError
     */
    public postPortalAgreementUpdate({
        body,
    }: {
        /**
         * requestUpdatePortalAgreement
         */
        body: api_portalAgreement_requestUpdatePortalAgreement,
    }): CancelablePromise<api_portalAgreement_responseUpdatePortalAgreement> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_agreement/update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
